export const EXTRA_CHARGES_WARNING_TEXT_SNACKBAR = `<b>Job was successfully activated.</b><br />\
This job uses an extra paid slot beyond your plan.`;
export const EXTRA_CHARGES_WARNING_TEXT = `<b>Your job slots are full.</b>
Activating this job adds a paid slot beyond your plan.`;
